var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgUnknown = function SvgUnknown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.374 24.895c0-2.258.277-4.056.83-5.395.554-1.339 1.563-2.653 3.028-3.944 1.481-1.306 2.466-2.362 2.955-3.169.488-.822.732-1.685.732-2.589 0-2.725-1.27-4.088-3.81-4.088-1.204 0-2.172.37-2.905 1.113-.716.725-1.09 1.733-1.123 3.024H0c.033-3.08 1.034-5.492 3.003-7.234C4.99.87 7.691 0 11.11 0c3.45 0 6.129.83 8.033 2.492C21.048 4.137 22 6.468 22 9.484c0 1.37-.31 2.67-.928 3.895-.618 1.21-1.7 2.556-3.247 4.04l-1.978 1.863c-1.237 1.178-1.945 2.557-2.124 4.137l-.098 1.476H7.374Zm-.708 7.428c0-1.081.366-1.968 1.099-2.662.749-.71 1.7-1.064 2.856-1.064s2.1.355 2.833 1.064c.749.694 1.123 1.58 1.123 2.662 0 1.064-.366 1.943-1.099 2.637-.716.693-1.668 1.04-2.857 1.04-1.188 0-2.148-.347-2.88-1.04-.717-.694-1.075-1.573-1.075-2.637Z",
    fill: "#3C4953"
  })));
};

export default SvgUnknown;